import * as Yup from 'yup'
import { useState, useCallback, useRef } from 'react'
import { FormikProps } from 'formik' // Importez FormikProps pour typer la référence correctement

import { actions } from '../../../redux'
import { Icons } from '../../../components/Icon'
import { StepProps } from '../../../types'
import { ActionButtonVariant, ActionButtonLook } from '../../../components/ActionButton/styled'

export const useIntentStep = (props: StepProps): any => {
  const { t, dispatch, formValues } = props
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [hasConfirmed, setHasConfirmed] = useState(false) // Flag pour éviter la réouverture immédiate

  // Typage explicite de la référence pour un formulaire Formik
  const ref = useRef<FormikProps<any>>(null)

  const handleCloseModal = useCallback((resetForm: () => void) => {
    setIsOpenModal(false)
    setHasConfirmed(false) // Réinitialiser le flag une fois la modale fermée
    resetForm() // Appeler resetForm correctement
  }, [])

  return {
    stepPart: {
      text: t('declaration.form.stepPart.myDeclaration'),
    },
    label: t('declaration.form.intent.label'),
    form: {
      innerRef: ref, // Associe la référence à Formik
      initialValues: {
        intent: formValues.intent,
      },
      validationSchema: Yup.object().shape({
        intent: Yup.string().required(),
      }),
      onContextUpdate: (context: { values: { intent: any } }) => {
        const intentValue = context.values.intent
        if (intentValue === '0' && !hasConfirmed) {
          setIsOpenModal(true)
        }
        if (intentValue === '1' && hasConfirmed) {
          setHasConfirmed(false)
        }
      },
      onSubmit: (values: { intent: string }) => {
        if (values.intent === '0') {
          dispatch(actions.declaration.resetDeclarations())
          dispatch(actions.declaration.setStep(5))
        } else {
          dispatch(actions.declaration.setNextStep())
        }

        dispatch(
          actions.declaration.setFormValues({
            name: 'intent',
            value: values.intent,
          })
        )
      },
      validateOnChange: false,
    },
    fields: [
      {
        field: {
          name: 'intent',
          required: true,
          allowMultiple: false,
          options: [
            {
              label: t('declaration.form.intent.option.declare'),
              value: '1',
            },
            {
              label: t('declaration.form.intent.option.nothing'),
              value: '0',
            },
          ],
        },
        type: 'toggle',
      },
    ],
    button: {
      text: t('declaration.form.intent.submit.label'),
      disabled: false,
      iconProps: {
        icon: Icons.arrowRight,
      },
      iconPosition: 'right',
    },
    modalProps: {
      isOpen: isOpenModal,
      onClose: () => {
        if (ref.current) {
          handleCloseModal(ref.current.resetForm) // Appel correct de resetForm
        }
      },
    },
    deleteModal: {
      title: t('declaration.form.stepPart.myDeclaration.modal.title'),
      text: t('declaration.form.stepPart.myDeclaration.modal.text'),
      buttons: [
        {
          variant: ActionButtonVariant.whiteWithBorder,
          look: ActionButtonLook.contained,
          text: t('declaration.form.stepPart.myDeclaration.modal.label.cancel'),
          bigPadding: true,
          onClick: () => {
            if (ref.current) {
              handleCloseModal(ref.current.resetForm)
            }
          },
        },
        {
          variant: ActionButtonVariant.primary,
          look: ActionButtonLook.contained,
          text: t('declaration.form.stepPart.myDeclaration.modal.label.submit'),
          bigPadding: true,
          onClick: () => {
            setHasConfirmed(true)
            setIsOpenModal(false)
          },
        },
      ],
    },
  }
}
